import { createSliceWithThunks } from '@castlery/shared-redux-core';
import type { Zipcode } from '../entity/zipcode.entity';
import { ExtraArgument } from '@castlery/shared-redux-extra';
import {
  EcEnv,
  enableZipCode,
  WEB_CHANNEL,
  globalDefaultCity,
  currentDefaultCity,
  EcErrorCode,
} from '@castlery/config';
import { createSelector } from '@reduxjs/toolkit';
import { capitalize } from '@castlery/utils';

export const ZIPCODE_FEATURE_KEY = 'zipcode';

export const zipcodeSlice = createSliceWithThunks({
  name: 'zipcode',
  initialState: {
    ...currentDefaultCity,
    canApply: true,
    canFindSKU: true,
  } as {
    city: string;
    state: string;
    zipcode: string;
    isOpenZipcodeFailureModal: boolean;
    canApply?: boolean;
    canFindSKU?: boolean;
    prevCorrectShippingLocation?: Zipcode;
    errorInfo?: {
      errorZipcode?: string;
      errorCode?: number;
    };
  },
  reducers: (create) => {
    return {
      initDefaultZipcode: create.asyncThunk(async (_, { dispatch, extra }) => {
        const { persistenceHandles } = extra as ExtraArgument;
        if (EcEnv.NEXT_PUBLIC_CHANNEL.toLowerCase() === WEB_CHANNEL.toLowerCase()) {
          // const city = persistenceHandles.webCity.getItem();
          // if (!city) {
          //   const initCity = currentDefaultCity;
          //   persistenceHandles.city.setItem(JSON.stringify(initCity));
          // } else {
          //   const cityInfo = JSON.parse(city);
          //   dispatch(noticeCityInfoUpdated(cityInfo));
          //   return JSON.parse(city);
          // }
          const city = persistenceHandles.webCity.getItem();
          if (!city) {
            const initCity = currentDefaultCity;
            persistenceHandles.webCity.setItem(JSON.stringify(initCity));
          } else {
            const cityInfo = JSON.parse(city);
            dispatch(noticeCityInfoUpdated(cityInfo));
            return JSON.parse(city);
          }
        } else {
          const city = await persistenceHandles.city.getItem();
          if (!city) {
            let initCity = globalDefaultCity;

            // let initCity = {
            //   city: 'Los Angeles',
            //   state: 'CA',
            //   zipcode: '90024',
            // };
            // if (EcEnv.NEXT_PUBLIC_COUNTRY === 'AU') {
            //   initCity = {
            //     city: 'Sydney',
            //     state: 'NSW',
            //     zipcode: '2000',
            //   };
            // }
            // if (EcEnv.NEXT_PUBLIC_COUNTRY === 'CA') {
            //   initCity = {
            //     // todo: 从统一的地方配置 default city
            //     city: 'Toronto',
            //     state: 'ON',
            //     zipcode: 'M5H 2N1',
            //   };
            // }
            if (enableZipCode) {
              initCity = currentDefaultCity;
              console.log('🚀 ~ initDefaultZipcode:create.asyncThunk ~ initCity:', initCity);
              await persistenceHandles.city.setItem(JSON.stringify(initCity));
            }
            return initCity;
          } else {
            console.log('🚀 ~ initDefaultZipcode:create.asyncThunk ~ JSON.parse(city):', JSON.parse(city));
            return JSON.parse(city);
          }
        }
      }),
      getCityInfo: create.asyncThunk(async (_, { extra }) => {
        const { persistenceHandles } = extra as ExtraArgument;
        const city = await persistenceHandles.city.getItem();
        if (EcEnv.NEXT_PUBLIC_CHANNEL.toLowerCase() === WEB_CHANNEL.toLowerCase()) {
          // if (city) {
          //   console.log('🚀 ~ getCityInfo:create.asyncThunk ~ city:', city);
          //   return JSON.parse(city);
          // } else {
          //   const webCity = persistenceHandles.webCity.getItem();
          //   if (webCity) {
          //     return JSON.parse(webCity as string);
          //   }
          //   return null;
          // }
          const webCity = persistenceHandles.webCity.getItem();
          if (webCity) {
            return JSON.parse(webCity as string);
          }
          return null;
        } else if (city) {
          console.log('🚀 ~ getCityInfo:create.asyncThunk ~ city:', city);
          return JSON.parse(city);
        }
        return null;
      }),
      noticeCityInfoUpdated: create.reducer((state, { payload }: { payload: Zipcode }) => {
        state.city = capitalize(payload.city);
        state.state = payload.state;
        state.zipcode = payload.zipcode;
      }),
      updateCityCanBeApply: create.reducer((state, { payload }: { payload: boolean }) => {
        state.canApply = payload;
      }),
      updateCanFindSKU: create.reducer((state, { payload }: { payload: boolean }) => {
        state.canFindSKU = payload;
      }),
      updatePrevCorrectShippingLocation: create.reducer((state, { payload }: { payload: Zipcode }) => {
        state.prevCorrectShippingLocation = payload;
      }),
      updateErrorInfo: create.reducer(
        (state, { payload }: { payload: { errorZipcode?: string; errorCode?: number } }) => {
          state.errorInfo = payload;
        }
      ),
      updateIsOpenZipcodeFailureModal: create.reducer((state, { payload }: { payload: boolean }) => {
        state.isOpenZipcodeFailureModal = payload;
      }),
    };
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type === 'zipcode/updateErrorInfo',
      (state, action) => {
        if ((action as any)?.payload?.errorCode === EcErrorCode.ZIPCODE_FAILURE) {
          state.isOpenZipcodeFailureModal = true;
        }
      }
    );
  },
  selectors: {
    selectedCurrentCity: (state) => state.city,
    selectedCurrentState: (state) => state.state,
    selectedCurrentZipcode: (state) => state.zipcode,
    selectedCurrentCityInfo: (state) => state,
    selectedCurrentCityCanBeApply: (state) => state.canApply,
    selectedCurrentCanFindSKU: (state) => state.canFindSKU,
    selectedPrevCorrectShippingLocation: (state) => state.prevCorrectShippingLocation,
    selectedErrorInfo: (state) => state.errorInfo,
    selectedIsOpenZipcodeFailureModal: (state) => state.isOpenZipcodeFailureModal,
  },
});
export const {
  initDefaultZipcode,
  getCityInfo,
  noticeCityInfoUpdated,
  updateCityCanBeApply,
  updateCanFindSKU,
  updatePrevCorrectShippingLocation,
  updateErrorInfo,
  updateIsOpenZipcodeFailureModal,
} = zipcodeSlice.actions;
export const {
  selectedCurrentCity,
  selectedCurrentState,
  selectedCurrentZipcode,
  selectedCurrentCityInfo,
  selectedCurrentCityCanBeApply,
  selectedCurrentCanFindSKU,
  selectedPrevCorrectShippingLocation,
  selectedErrorInfo,
  selectedIsOpenZipcodeFailureModal,
} = zipcodeSlice.selectors;

export const getZipcodeState = (rootState: { [ZIPCODE_FEATURE_KEY]: Zipcode }): Zipcode =>
  rootState[ZIPCODE_FEATURE_KEY];

export const selectShippingCityInfo = createSelector(
  [(state: { zipcode: Zipcode }) => getZipcodeState(state)],
  (zipcodeInfo) => {
    return {
      city: capitalize(zipcodeInfo.city),
      state: zipcodeInfo.state,
      zipcode: zipcodeInfo.zipcode,
    };
  }
);
